import React, {useState} from 'react';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import {motion} from 'framer-motion';
import {animationValues, transitionValues} from '../../../utils/pageTransitions';
import Customer from '../faq/user';
import Supplier from '../faq/supplier';

function Help() {

    const [active,
        setActive] = useState(false);

    const [create,
        setCreate] = useState(false);

    const [edit,
        setEdit] = useState(false);

    return (
        <motion.div
            initial='out'
            animate='in'
            exit='out'
            variants={animationValues}
            transition={transitionValues}>

            <div className="helpCenter">
                <Tabs>
                    <div className="row pt-4">
                        <div className={`col-md-2 py-2 nav`}>

                            <TabList className="p-0">
                                <Tab className={`textIsBold--semi sectionText--mid isClickable my-1 tabHead`}>Supplier</Tab>
                                <Tab className={`textIsBold--semi sectionText--mid isClickable my-1 tabHead`}>Customer</Tab>
                            </TabList>

                        </div>

                        <div className="col-md-10">

                            <div className="sectionHeight px-3">
                                <div className="w-100">
                                    <TabPanel>
                                        <Supplier/>
                                    </TabPanel>

                                    <TabPanel>
                                        <Customer/>
                                    </TabPanel>
                                </div>
                            </div>
                        </div>
                    </div>
                </Tabs>

            </div>

        </motion.div>
    )
}

export default Help
